import { SvgIcon } from "@material-ui/core";
import React from "react";
import pure from "recompose/pure";

const DocIcon = ({color = "#2B3940", ...props}) => (
  <SvgIcon {...props} viewBox="0 0 16 16" fill="none"  >
    <path d="M6 0H1C0.4 0 0 0.4 0 1V14C0 14.6 0.4 15 1 15H12C12.6 15 13 14.6 13 14V7C13 3.1 9.9 0 6 0ZM11.2 5.2L8 5L7.8 1.8C9 2 11 4 11.2 5.2ZM11.3 13.3H1.7V1.7H6C6.1 1.7 6.2 1.7 6.4 1.7V6.6H11.3C11.3 6.7 11.3 6.8 11.3 7V13.3Z" fill={color} />
  </SvgIcon>
);
DocIcon.displayName = "DocIcon";
DocIcon.muiName = "SvgIcon";

export default pure(DocIcon);